module.exports = __webpack_public_path__ + "static/media/linkedin-feed.28d225ae.svg";